import React from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuthState} from "./auth/useAuthState";

// Guard for routes that are meaningless signed out (currently /account).
// Rather than a full-page sign-in wall, a guest is put back on the map with the
// sign-in dialog over it, and sent on to where they were headed once they are
// through it. Everything else in the app is reachable as a guest and gated
// action by action instead.
const AccessController = () => {
  const authState = useAuthState()
  const location = useLocation()

  // Session still resolving — deciding now would bounce a signed-in member.
  if (authState === "loading") return null

  if (authState === "guest") {
    return <Navigate to="/map" replace state={{signInRedirect: location.pathname}}/>
  }

  return <Outlet/>
}

export default AccessController
